
// Global state, for the most part obtained from the server
// when the single page UI is initialized (i.e. from page.html)
export interface GlobalState {
  projectId: string;
  databaseUrl: string;
  firebaseSenderId: string;
  firebaseAppId: string;
  firebaseApiKey: string;
  measurementId: string;
  account: string;
  userEmail: string;
  netskraflUserId: string; // Backend's internal user ID from /login_malstadur
  userNick: string;
  userFullname: string;
  locale: string;
  isExplo: boolean;
  serverUrl: string;
  movesUrl: string;
  movesAccessKey: string;
  token: string;
  loginMethod: string;
  subscriptionUrl: string;
  newUser: boolean;
  beginner: boolean;
  fairPlay: boolean;
  plan: string;
  hasPaid: boolean;
  audio: boolean;
  fanfare: boolean;
  ready: boolean;
  readyTimed: boolean;
  uiFullscreen: boolean;
  uiLandscape: boolean;
  runningLocal: boolean;
  userGroupId?: string; // For group-based scoring
  tokenExpired?: () => void; // Optional callback for token expiration
  onFirebaseReady?: () => void; // Optional callback when Firebase Database is initialized
}

export const DEFAULT_STATE: GlobalState = {
  projectId: "netskrafl",
  firebaseApiKey: "",
  databaseUrl: "",
  firebaseSenderId: "",
  firebaseAppId: "",
  measurementId: "",
  account: "",
  userEmail: "",
  netskraflUserId: "",
  userNick: "",
  userFullname: "",
  locale: "is_IS",
  isExplo: false,
  serverUrl: "",
  movesUrl: "",
  movesAccessKey: "",
  token: "",
  loginMethod: "",
  subscriptionUrl: "",
  newUser: false,
  beginner: true,
  fairPlay: false,
  plan: "", // Not a friend
  hasPaid: false,
  audio: false,
  fanfare: false,
  ready: true,
  readyTimed: true,
  uiFullscreen: true,
  uiLandscape: false,
  runningLocal: false,
};
